(function () {
  if (window.__storiesWidgetAssetLoaded) return;
  window.__storiesWidgetAssetLoaded = true;

  var STORY_DURATION = 3500;

  function initStoriesWidget(widget) {
    if (!widget || widget.dataset.storiesWidgetInitialized === 'true') return;

    var container = widget.querySelector('[data-stories-container]');
    var modal = widget.querySelector('[data-story-modal]');
    var videoElement = widget.querySelector('[data-story-video]');
    var closeButtons = widget.querySelectorAll('[data-story-close]');

    if (!container || !modal || !videoElement) return;

    var items = Array.from(container.querySelectorAll('.widde-item'));
    if (!items.length) return;

    var currentIndex = 0;
    var animationId = null;
    var isModalOpen = false;

    widget.dataset.storiesWidgetInitialized = 'true';

    function stopRing() {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
    }

    function onRingComplete() {
      if (items.length === 1) {
        startRing(0);
      } else {
        startRing((currentIndex + 1) % items.length);
      }
    }

    function startRing(index, fromProgress) {
      stopRing();

      items.forEach(function (item, itemIndex) {
        var progress = item.querySelector('.ring-progress');
        if (!progress) return;

        if (itemIndex !== index) {
          progress.style.strokeDashoffset = progress._perimeter;
        }
      });

      currentIndex = index;

      var progress = items[index] && items[index].querySelector('.ring-progress');
      if (!progress) return;

      var perimeter = progress._perimeter;
      var from = fromProgress || 0;
      var startTime = performance.now() - from * STORY_DURATION;

      function tick(now) {
        var delta = now - startTime;
        var fraction = Math.min(delta / STORY_DURATION, 1);
        progress.style.strokeDashoffset = perimeter * (1 - fraction);

        if (fraction < 1) {
          animationId = requestAnimationFrame(tick);
          return;
        }

        onRingComplete();
      }

      animationId = requestAnimationFrame(tick);
    }

    function pauseThumbVideos() {
      widget.querySelectorAll('[data-thumb-video]').forEach(function (v) {
        try { v.pause(); } catch (e) {}
      });
    }

    function resumeThumbVideos() {
      widget.querySelectorAll('[data-thumb-video]').forEach(function (v) {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
    }

    function openStoryModal(videoUrl, clickedIndex) {
      if (videoUrl) {
        videoElement.src = videoUrl;
      }

      modal.classList.add('active');
      isModalOpen = true;
      currentIndex = clickedIndex;
      videoElement.muted = false;

      var playPromise = videoElement.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          videoElement.muted = true;
          videoElement.play();
        });
      }

      pauseThumbVideos();
      stopRing();
    }

    function closeStoryModal() {
      modal.classList.remove('active');
      videoElement.pause();
      videoElement.src = '';
      isModalOpen = false;
      resumeThumbVideos();
      startRing(currentIndex);
    }

    items.forEach(function (item, idx) {
      var progress = item.querySelector('.ring-progress');
      if (!progress) return;

      progress.setAttribute('pathLength', '100');
      progress.style.strokeDasharray = '100';
      progress.style.strokeDashoffset = '100';
      progress._perimeter = 100;

      item.addEventListener('click', function () {
        openStoryModal(item.getAttribute('data-video-url'), idx);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeStoryModal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeStoryModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!isModalOpen || event.key !== 'Escape') return;
      closeStoryModal();
    });

    startRing(0);

    setupMobileReorder(widget);
    setupAutoplayThumbs(widget);
  }

  /**
   * Autoplay dos vídeos da thumb só quando a faixa entra no viewport.
   * Pausa quando sai. Sem IntersectionObserver, faz autoplay direto.
   */
  function setupAutoplayThumbs(widget) {
    var thumbs = widget.querySelectorAll('[data-thumb-video]');
    if (!thumbs.length) return;

    if (!('IntersectionObserver' in window)) {
      thumbs.forEach(function (v) {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            try { v.pause(); } catch (e) {}
          }
        });
      },
      { rootMargin: '120px', threshold: 0.1 }
    );

    thumbs.forEach(function (v) { io.observe(v); });
  }

  /**
   * Reordena o widget na PDP:
   *  - Mobile (≤990px): move pra primeiro filho de [product-container] → acima da galeria
   *  - Desktop (>990px): move pra primeiro filho de .main-product__details → acima do título
   */
  function setupMobileReorder(widget) {
    // Guard: quando o widget é renderizado em posição estática pelo Liquid
    // (com classe --mobile-only ou --desktop-only), o reorder via DOM é dispensado
    // — eliminamos o shift de layout pós-paint que gerava CLS na PDP.
    if (
      widget.classList.contains('widde-wrapper--mobile-only') ||
      widget.classList.contains('widde-wrapper--desktop-only')
    ) {
      return;
    }

    var productContainer = widget.closest('[product-container]');
    var detailsContainer = widget.closest('.main-product__details');
    if (!productContainer && !detailsContainer) {
      detailsContainer = document.querySelector('.main-product__details');
    }
    if (!productContainer && !detailsContainer) return;

    var mql = window.matchMedia('(max-width: 990px)');

    function moveToFirst(parent) {
      if (!parent) return;
      if (parent.firstElementChild !== widget) {
        parent.insertBefore(widget, parent.firstElementChild);
      }
    }

    function apply() {
      if (mql.matches) {
        moveToFirst(productContainer);
        widget.classList.add('widde-wrapper--mobile-top');
        widget.classList.remove('widde-wrapper--desktop-top');
      } else {
        moveToFirst(detailsContainer);
        widget.classList.remove('widde-wrapper--mobile-top');
        widget.classList.add('widde-wrapper--desktop-top');
      }
    }

    apply();

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', apply);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(apply);
    }
  }

  function initStoriesWidgets(root) {
    (root || document).querySelectorAll('[data-stories-widget]').forEach(initStoriesWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStoriesWidgets(document);
    });
  } else {
    initStoriesWidgets(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initStoriesWidgets(event.target);
  });
})();
